import React, { useState, useEffect } from 'react';
import { Col, Row } from '../../../../../components/base/BootstrapComponents/BootstrapComponents';
import FieldDTOWithCol from '../../../../../components/fields/Abstract/FieldDTOWithCol';
import Switches from '../../../../../components/fields/Switches/Switches';
import TextInputWithLabel from '../../../../../components/fields/TextInput/TextInputWithLabel';
import DateTimePicker from '../../../../../components/fields/DatePicker/DateTimePicker';
import FileInput from '../../../../../components/fields/FileInput/FileInput';
import CustomSelectInput from '../../../../../components/fields/SelectInput/CustomSelectInput';
import { OWNERSHIP_TYPE_LIST, PROCEDURE_TYPE } from '../../../../../configs';
import CarDTO from '../../../../../dto/CarDTO';

export default function VehicleCertificateForm(props) {
  const {
    prefix = 'application_vehicle_new.',
    control,
    formMeta,
    procedure,
    federal_law_number,
    isEdit = false,
    currentApplication = {},
    setValue,
    getValues,
  } = props;

  const dto = new CarDTO({ procedure, federal_law_number });
  const attributes = dto.getAttributesByName();

  const [showVehicleCertificate, setShowVehicleCertificate] = useState(
    isEdit ? !!(
      currentApplication?.application_vehicle_new?.vehicle_registration_number
                || currentApplication?.application_vehicle_new?.vehicle_registration_issue_date
                || currentApplication?.application_vehicle_new?.has_special_lifting_device
                || currentApplication?.application_vehicle_new?.ownership_type
    ) || currentApplication?.application_vehicle_new?.vehicle_registration_number === null
            || currentApplication?.application_vehicle_new?.vehicle_registration_issue_date === null
            || currentApplication?.application_vehicle_new?.has_special_lifting_device === null
            || currentApplication?.application_vehicle_new?.ownership_type === null : false,
  );

  useEffect(() => {
    setValue('application_vehicle_new.vehicle_registration_number', !showVehicleCertificate ? null : (isEdit ? getValues('application_vehicle_new.vehicle_registration_number') || '' : ''));
    setValue('application_vehicle_new.vehicle_registration_issue_date', !showVehicleCertificate ? null : (isEdit ? getValues('application_vehicle_new.vehicle_registration_issue_date') || '' : ''));
    setValue('application_vehicle_new.has_special_lifting_device', !showVehicleCertificate ? null : (isEdit ? getValues('application_vehicle_new.has_special_lifting_device') || '' : ''));
    setValue('application_vehicle_new.ownership_type', !showVehicleCertificate ? null : (isEdit ? getValues('application_vehicle_new.ownership_type') || '' : ''));
    if (!showVehicleCertificate) setValue('media.car_photo_file', null);
  }, [showVehicleCertificate]);

  if (![PROCEDURE_TYPE.PROCEDURE_1227_8].includes(procedure)) {
    return null;
  }

  return (
    <>
      <Row className="row-cols-1">
        <Col>
          <Switches
            type="text"
            variant="material"
            inputProps={{
              onChange: () => setShowVehicleCertificate(!showVehicleCertificate),
              value: showVehicleCertificate,
            }}
            label="Изменились сведения о СТС"
          />
        </Col>
      </Row>

      {showVehicleCertificate && (
        <>
          <Row className="row-cols-3">
            <FieldDTOWithCol
              control={control}
              type="text"
              component={TextInputWithLabel}
              dtoObject={attributes.vehicle_registration_number}
              variant="material"
              namePrefix={prefix}
              formMeta={formMeta}
              labelPrefix="new."
            />
            <FieldDTOWithCol
              control={control}
              type="text"
              component={DateTimePicker}
              hideTime
              changeFormat="YYYY-MM-DD"
              withLabel
              dtoObject={attributes.vehicle_registration_issue_date}
              variant="material"
              namePrefix={prefix}
              formMeta={formMeta}
              labelPrefix="new."
            />
            <FieldDTOWithCol
              control={control}
              formMeta={formMeta}
              type="text"
              component={FileInput}
              dtoObject={attributes.applicant_car_cd_file}
              variant="material"
              namePrefix="media."
              textarea
              multiple
            />
          </Row>

          <Row className="row-cols-1">
            <FieldDTOWithCol
              control={control}
              type="text"
              component={Switches}
              dtoObject={attributes.has_special_lifting_device}
              variant="material"
              namePrefix={prefix}
              withLabel
              formMeta={formMeta}
              labelPrefix="new."
            />
          </Row>

          <Row className="row-cols-3">
            <FieldDTOWithCol
              control={control}
              component={CustomSelectInput}
              dtoObject={attributes.ownership_type}
              variant="material"
              namePrefix={prefix}
              withLabel
              options={OWNERSHIP_TYPE_LIST}
              formMeta={formMeta}
              labelPrefix="new."
            />
            <FieldDTOWithCol
              control={control}
              formMeta={formMeta}
              type="text"
              component={FileInput}
              dtoObject={attributes.car_photo_file}
              variant="material"
              namePrefix="media."
              textarea
              multiple
            />
          </Row>
        </>
      )}

      <div className="hr-row mt-3" />
    </>
  );
}
